import lang from "vue2-datepicker/locale/es/ru";
lang.monthFormat = "MMMM";
const dateSelector = {
  dateSelector: {
    datepickerLang: lang,
    placeholder: "Выберите даты",
  },
};

export { dateSelector };
